import StandardError from '../StandardError'

export default class NotScheduledError extends StandardError {
  constructor() {
    super('Message not scheduled')
  }
}
